<div style="padding-right: 3%; padding-left: 3%">
  <form [formGroup]="createForm">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <app-cards
          [title]="'organization.organization-information' | translate"
          footerDivider="border-0 pb-0 "
          class="custom-cardbox-area"
        >
          <div bodyContent>
            <ng-container>
              <div class="row mb-2">
                <label for="dotName" class="form-label font-w500"
                >{{
                    "organization.organization-name" | translate
                  }}<span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    formControlName="name"
                    placeholder="Organizasyon adı giriniz"
                  />
                </div>
                <div
                  *ngIf="
                    createForm.get('name')?.invalid &&
                    createForm.get('name')?.touched
                  "
                  class="text-danger"
                >
                  <small *ngIf="createForm.get('name')?.errors?.['required']">{{
                      "validation.required" | translate
                    }}</small>
                </div>
              </div>
              <div class="row mb-2">
                <label for="organizationType" class="form-label"
                >{{
                    "organization.organization-type" | translate
                  }}<span class="text-danger">*</span></label
                >

                <p-dropdown
                  [options]="orgTypes"
                  formControlName="organizationType"
                  [showClear]="true"
                  [placeholder]="'general.select-please' | translate"
                >
                </p-dropdown>
                <div
                  *ngIf="
                    createForm.get('organizationType')?.invalid &&
                    createForm.get('organizationType')?.touched
                  "
                  class="text-danger"
                >
                  <small
                    *ngIf="createForm.get('organizationType')?.errors?.['required']"
                  >{{ "validation.required" | translate }}</small
                  >
                </div>
              </div>

              <div class="row mb-2">
                <label for="instituation" class="form-label"
                >{{
                    "organization.instituation-label" | translate
                  }}<span class="text-danger">*</span></label
                >
                <p-dropdown
                  [options]="instutuationTypes"
                  formControlName="instituation"
                  [showClear]="true"
                  [placeholder]="'general.select-please' | translate"
                >
                </p-dropdown>
                <div
                  *ngIf="
                    createForm.get('instituation')?.invalid &&
                    createForm.get('instituation')?.touched
                  "
                  class="text-danger"
                >
                  <small
                    *ngIf="createForm.get('instituation')?.errors?.['required']"
                  >{{ "validation.required" | translate }}</small
                  >
                </div>
              </div>

              <div class="row mb-2">
                <label for="description" class="form-label">{{
                    "organization.description" | translate
                  }}</label>
                <div class="input-group">
                  <textarea
                    formControlName="description"
                    class="form-control"
                    rows="2"
                    id="description"
                    [placeholder]="
                      'organization.description-placeholder' | translate
                    "
                  ></textarea>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-xl-6 col-sm-12">
                  <label for="amount" class="form-label">{{
                      "organization.amount" | translate
                    }}</label>
                  <input
                    type="number"
                    class="form-control"
                    appPreventNegativeInput
                    [min]="0"
                    id="amount"
                    formControlName="amount"
                    [placeholder]="
                      'organization.amount-placeholder' | translate
                    "
                  />
                </div>
                <div class="col-xl-6 col-sm-12">
                  <label for="protocolNo" class="form-label">{{
                      "organization.protocol-no" | translate
                    }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="protocolNo"
                    formControlName="protocolNo"
                    [placeholder]="
                      'organization.protocol-no-placeholder' | translate
                    "
                  />
                </div>
              </div>

              <div class="row mb-2">
                <div class="col-xl-6 col-sm-12">
                  <label for="ambulanceCount" class="form-label">{{
                      "organization.ambulance-no" | translate
                    }}</label>
                  <input
                    type="number"
                    class="form-control"
                    appPreventNegativeInput
                    [min]="0"
                    id="ambulanceCount"
                    formControlName="ambulanceCount"
                    [placeholder]="
                      'organization.ambulance-placeholder' | translate
                    "
                  />
                </div>
                <div class="col-xl-6 col-sm-12">
                  <label for="vehicleNo" class="form-label">{{
                      "organization.vehicle-no" | translate
                    }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="vehicleNo"
                    formControlName="vehicleNo"
                  />
                </div>
              </div>
              <div class="row-mb-2">
                <label for="plannedVehicles" class="form-label">{{
                    "organization.planned-vehicles" | translate
                  }}</label>
                <p-multiSelect
                  [options]="vehicles"
                  formControlName="plannedVehicles"
                  appendTo="body"
                  [placeholder]="'organization.planned-vehicles' | translate"
                  [filter]="true"
                >
                </p-multiSelect>
              </div>
              <div
                class="row mt-4"
                *ngIf="plannedVehiclesList && plannedVehiclesList.length > 0"
              >
                <div class="col-12">
                  <h5>Planlanan Araçlar</h5>
                  <table class="table table-bordered table-sm">
                    <thead>
                    <tr>
                      <th scope="col">Plaka</th>
                      <th scope="col">112 Protokol No</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let item of plannedVehiclesList">
                      <td>{{ item?.vehicle?.licensePlate }}</td>
                      <td>
                        <input
                          [ngModelOptions]="{ standalone: true }"
                          type="text"
                          class="form-control"
                          [(ngModel)]="item.protocolNo112"
                          [placeholder]="
                              'organization.protocol-no' | translate
                            "
                        />
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
        </app-cards>
      </div>
      <div class="col-xl-4 col-md-4 col-sm-12">
        <app-cards
          [title]="'organization.date-information' | translate"
          footerDivider="border-0 pb-0 "
          class="custom-cardbox-area"
        >
          <div bodyContent>
            <ng-container>
              <div class="row mb-2">
                <div class="col-xl-6 col-sm-12">
                  <label for="startDate" class="form-label"
                  >{{
                      "organization.start-date-label" | translate
                    }}<span class="text-danger">*</span></label
                  >

                  <p-calendar
                    formControlName="startDate"
                    [placeholder]="'organization.start-date' | translate"
                    appendTo="body"
                  >
                  </p-calendar>
                  <div
                    *ngIf="
                      createForm.get('startDate')?.invalid &&
                      createForm.get('startDate')?.touched
                    "
                    class="text-danger"
                  >
                    <small
                      *ngIf="createForm.get('startDate')?.errors?.['required']"
                    >{{ "validation.required" | translate }}</small
                    >
                  </div>
                </div>
                <div class="col-xl-6 col-sm-12">
                  <label for="startTime" class="form-label"
                  >{{
                      "organization.start-time-label" | translate
                    }}<span class="text-danger">*</span></label
                  >

                  <p-calendar
                    name="startTime"
                    formControlName="startTime"
                    [timeOnly]="true"
                    [placeholder]="
                      'organization.start-time-placeholder' | translate
                    "
                  >
                  </p-calendar>
                  <div
                    *ngIf="
                      createForm.get('startTime')?.invalid &&
                      createForm.get('startTime')?.touched
                    "
                    class="text-danger"
                  >
                    <small
                      *ngIf="createForm.get('startTime')?.errors?.['required']"
                    >{{ "validation.required" | translate }}</small
                    >
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-xl-6 col-sm-12">
                  <label for="duration" class="form-label"
                  >{{
                      "organization.duration-label" | translate
                    }}<span class="text-danger">*</span></label
                  >

                  <div style="display: flex; gap: 10px; align-items: center">
                    <div style="flex: 1">
                      <input
                        type="number"
                        class="form-control"
                        formControlName="durationHours"
                        name="durationHours"
                        [min]="0"
                        [max]="23"
                        appPreventNegativeInput
                        [placeholder]="'case.person-card.hour' | translate"
                      />
                    </div>
                    :
                    <div style="flex: 1">
                      <input
                        type="number"
                        class="form-control"
                        formControlName="durationMinutes"
                        name="durationMinutes"
                        [min]="0"
                        [max]="59"
                        appPreventNegativeInput
                        [placeholder]="'case.person-card.minute' | translate"
                      />
                    </div>
                  </div>
                  <div
                    *ngIf="
                      createForm.get('duration')?.invalid &&
                      createForm.get('duration')?.touched
                    "
                    class="text-danger"
                  >
                    <small
                      *ngIf="createForm.get('duration')?.errors?.['required']"
                    >{{ "validation.required" | translate }}</small
                    >
                  </div>
                </div>

                <div class="col-xl-6 col-sm-12">
                  <label for="endTime" class="form-label"
                  >{{
                      "organization.datetime-label" | translate
                    }}<span class="text-danger">*</span></label
                  >

                  <app-readonly-input
                    [showHour]="true"
                    [value]="createForm.controls['endDate']?.value"
                    [type]="'date'"
                  ></app-readonly-input>
                </div>

                <div class="col-xl-12 col-sm-12 mt-2" *ngIf="!orgId">
                  <label for="isRecurring">{{
                      "organization.recurring" | translate
                    }}</label>
                  <div class="checkbox-group">
                    <input
                      type="checkbox"
                      id="isRecurring"
                      formControlName="isRecurring"
                      name="isRecurring"
                    />
                  </div>
                </div>
              </div>

              <div class="row px-4" *ngIf="!orgId">
                <div
                  class="col-md-12 recurring-card"
                  [class.open]="createForm.controls['isRecurring']?.value"
                >
                  <div
                    class="row mb-2 justify-content-center align-items-center"
                  >
                    <p-calendar
                      formControlName="recurringDate"
                      name="appointmentDate"
                      appendTo="body"
                      class="col-md-6 mb-2"
                      [minDate]="createForm.controls['startDate']?.value"
                    >
                    </p-calendar>
                    <label class="col-md-6 mb-2" for="">{{
                        "case.person-card.to-date" | translate
                      }}</label>
                  </div>

                  <div
                    class="row mb-2 justify-content-center align-items-center"
                  >
                    <p-dropdown
                      [options]="days"
                      class="col-md-6 mb-2"
                      formControlName="frequency"
                      appendTo="body"
                    >
                    </p-dropdown>

                    <label class="col-md-6 mb-2" for="">{{
                        "case.person-card.frequency" | translate
                      }}</label>
                  </div>

                  <div class="row mt-4" *ngIf="recurrings.length > 0">
                    <div class="col-12">
                      <table
                        class="table table-bordered table-striped text-center"
                      >
                        <thead>
                        <tr>
                          <th scope="col">
                            {{
                              "case.person-card.start-date-hour" | translate
                            }}
                          </th>
                          <th scope="col">
                            {{ "case.person-card.end-date-hour" | translate }}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let recurring of recurrings">
                          <td>
                            {{ recurring.startDate | dateFormat : true }}
                          </td>
                          <td>{{ recurring.endDate | dateFormat : true }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </app-cards>
      </div>
      <div class="col-xl-4 col-md-4 col-sm-12">
        <app-cards
          [title]="'organization.communication-information' | translate"
          footerDivider="border-0 pb-0 "
          class="custom-cardbox-area"
        >
          <div bodyContent>
            <ng-container>
              <div class="row mb-2">
                <label for="authorizedPerson" class="form-label font-w500"
                >{{
                    "organization.authorized-person" | translate
                  }}<span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    id="authorizedPerson"
                    formControlName="authorizedPerson"
                    placeholder="Yetkili Adı giriniz"
                  />
                </div>
                <div
                  *ngIf="
                    createForm.get('authorizedPerson')?.invalid &&
                    createForm.get('authorizedPerson')?.touched
                  "
                  class="text-danger"
                >
                  <small
                    *ngIf="createForm.get('authorizedPerson')?.errors?.['required']"
                  >{{ "validation.required" | translate }}</small
                  >
                </div>
              </div>

              <div class="row mb-2">
                <label for="authorizedPhone" class="form-label font-w500"
                >{{
                    "organization.authorized-person-phone-label" | translate
                  }}<span class="text-danger">*</span></label> <small>Başında 0 olmadan 10 haneli</small> 
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    id="authorizedPhone"
                    formControlName="authorizedPhone"
                    placeholder="Yetkili Telefonu giriniz"
                    maxlength="10"
                    (keypress)="onlyNumber($event)"
                    (input)="formatPhone($event)"
                  />
                </div>
                <div
                  *ngIf="
                    createForm.get('authorizedPhone')?.invalid &&
                    createForm.get('authorizedPhone')?.touched
                  "
                  class="text-danger"
                >
                  <small
                    *ngIf="createForm.get('authorizedPhone')?.errors?.['required']"
                  >{{ "validation.required" | translate }} Başında 0 olmadan 10 haneli</small
                  >
                </div>
              </div>
              <core-address-input
                [form]="createForm"
                (openModal)="openAddressModal()"
                [showMapButton]="false"
              ></core-address-input>

              <div class="row mb-2">
                <div class="col-xl-12 col-sm-12" *ngIf="editable">
                  <span>{{ "organization.status" | translate }}</span>
                  <app-readonly-input
                    [value]="
                      createForm.controls['status'].value
                        | organizationStatusPipe
                    "
                  ></app-readonly-input>
                </div>
              </div>

              <!--<div class="row mb-2">
                <div class="col-xl-12 col-sm-12" *ngIf="editable">
                  <span>{{ "organization.with-doctor" | translate }}</span>
                  <app-readonly-input
                    [value]="
                      createForm.controls['status'].value
                        | organizationStatusPipe
                    "
                  ></app-readonly-input>
                </div>
              </div>-->

              <div
                class="row mb-2"
                *ngIf="createForm.getRawValue().status !== 'completed'"
              >
                <div class="col-xl-12 col-sm-6" *ngIf="editable">
                  <span>{{ "organization.cancel" | translate }}</span>
                  <div
                    class="form-check form-switch d-flex justify-content-between col-xl-12"
                  >
                    <input
                      class="form-check-input"
                      formControlName="cancelled"
                      type="checkbox"
                      role="switch"
                      id="cancelled"
                      aria-checked="false"
                    />
                  </div>
                </div>
              </div>
              <div
                class="row"
                *ngIf="
                  isCancelled && createForm.getRawValue().status !== 'completed'
                "
              >
                <label for="cancelDescription" class="required-star">{{
                    "organization.cancel-description" | translate
                  }}</label>
                <div class="input-group">
                  <textarea
                    formControlName="cancelDescription"
                    class="form-control"
                    rows="5"
                    id="cancelDescription"
                    placeholder="İptal nedenini belirtiniz..."
                  ></textarea>
                </div>
              </div>
            </ng-container>
          </div>
        </app-cards>
      </div>
    </div>
  </form>
</div>

<core-address-autocomplete
  #addressComponent
  [parentForm]="createForm"
  (setAddress)="handleSetAddress($event)"
></core-address-autocomplete>
